import { BasicFile } from '@vmware-react/clarity/dist/basic-inputs';
import React from 'react';
import { DFileField, DFileValue } from './types';

interface Props {
  field: DFileField;
  value: DFileValue;
  error?: string;
  touched?: boolean;
  hidden?: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  handleReset: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default (props: Props) => {
  const {
    field,
    error,
    touched,
    hidden,
    value,
    handleChange,
    handleBlur,
    handleReset
  } = props;
  const hasError = typeof error === 'string' && error.length > 0;

  return (
    <BasicFile
      label={field.label}
      required={field.required}
      btnLabel={field.btnLabel}
      hidden={hidden}
      error={hasError && touched}
      errorMessage={error}
      helpText={field.helperText}
      helpTextPosition={field.helperTextPosition}
      helperTextToolTipConfig={field.helperTextToolTipConfig}
      disabled={field.disabled}
      placeholder={field.placeholder}
      name={field.name}
      value={value as File}
      onBlur={handleBlur}
      onChange={handleChange}
      onReset={handleReset}
    />
  );
};
